import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { ImagePath } from "../../../../../assets/ImagePath";
import { BotApiServices } from "../../../../../services/api/BotApiServices";
import { isCompleteUrl } from "../../../../../utils/general";
import config from "../../../../../utils/config/config";

// Cache to store downloaded image URLs
const imageCache = new Map();

const createPopupContent = (point, isLoading, imageUrl) => {
    const primaryKeys = point?._primaryKeys || {};


    const dynamicFields = Object.entries(point || {})
        .filter(([key]) => !["showInPreviewFields", "_primaryKeys", "rowOptions", "Location",
            "iconUrl", "_parentKey", "_terminalUpdateId", "locationSource"].includes(key))
        .map(([key, value]) => {
            const isPrimary = Object.prototype.hasOwnProperty.call(primaryKeys, key);
            const displayValue = value ?? "-";

            return `
             <div class="inner-modal">
                   <p>${key}</p>
                   <span  ${isPrimary ? `data-key="${key}" data-value="${point._terminalUpdateId}"` : ""} class="${isPrimary ? 'primary-key' : 'text-[#252f4a]'}">${displayValue}</span>
              </div>
             `;
        })
        .join("");

    return `
        <style>
            .primary-key {
                color: #376AFA !important;
                cursor: pointer !important;
                font-weight: 600;
            }
            .popup-close-btn {
                position: absolute;
                top: 15px;
                right: 15px;
                width: 12px;
                height: 12px;
                cursor: pointer;
                z-index: 10;
            }
        </style>

        <div class="popup-content-wrapper" style="position: relative;">
            <div class="popup-close-btn" title="Close">
                <img src="${ImagePath.closeIcon}" width="20px" alt="closeIcon" />
            </div>

            <div class="h-[131px] w-full bg-[#dde2e2] rounded-t-[16px] flex items-center justify-center overflow-hidden">
                ${isLoading
            ? `<div class="show-img-loader"></div>`
            : `<img class="img-full" src="${imageUrl}" alt="Vessel" />`}
            </div>

            <div class="mapboxgl-popup-content-inner-body">
                ${dynamicFields}
            </div>
        </div>
    `;
};



const handlePopupImageContent = async (vesselDetail, fileScope, scopeId, user) => {
    const imageUrl = vesselDetail["Image URL"];
    if (!imageUrl || !user?.isOnline) return ImagePath.boatDummy;

    //Check if image is already cached
    if (imageCache.has(imageUrl)) return imageCache.get(imageUrl);
    if (isCompleteUrl(imageUrl)) return imageUrl;

    try {
        const url = `${config.filesAPI}/downloadwithsignedurl/${fileScope || "conversation"}/${scopeId}/${imageUrl}`;
        console.log("Fetching file:", url);

        const response = await BotApiServices.downloadSignedUrlFile(url);
        const signedUrl = response?.data?.signedUrl;
        if (!signedUrl) return ImagePath.boatDummy;

        //Download and cache the image
        const downloadedImage = await downloadImageFromSignedUrl(signedUrl);
        imageCache.set(imageUrl, downloadedImage);
        return downloadedImage;
    } catch (error) {
        console.error("Error fetching image:", error);
        return ImagePath.emmaBot;
    }
};


const downloadImageFromSignedUrl = async (signedUrl) => {
    try {
        const fileResponse = await BotApiServices.downloadFile(signedUrl);
        if (!fileResponse?.data) throw new Error("Invalid file response");

        const blob = new Blob([fileResponse.data], { type: fileResponse.headers["content-type"] || "image/jpeg" });
        return window.URL.createObjectURL(blob);
    } catch (error) {
        console.error("Error downloading file:", error);
        return ImagePath.boatDummy;
    }
};


export const markerPopUpContent = async (point, fileScope, scopeId, user, mapInstance, handleOnAction) => {
    if (!mapInstance) return console.error("Map instance is undefined. Popup cannot be added.");

    let isLoading = true;
    let imageUrl = ImagePath.boatDummy;

    // Show popup with loader first
    const popup = new mapboxgl.Popup({
        offset: [-39, 0], anchor: "top", // offset to make the popup anchor on top center of marker 
        className: "custom-popup"
    })
        .setLngLat([point?.longitude ?? "", point?.latitude ?? ""])
        .setHTML(createPopupContent(point, isLoading, imageUrl))
        .addTo(mapInstance);

    try {
        handlePopupImageContent(point, fileScope, scopeId, user).then(downloadedImageUrl => {
            if (downloadedImageUrl) {
                imageUrl = downloadedImageUrl;
                isLoading = false;
                popup.setHTML(createPopupContent(point, isLoading, imageUrl));
            }
        })
    } catch (error) {
        console.error("Failed to load image:", error);
    }

    setTimeout(() => {
        const popupEl = document.querySelector(".mapboxgl-popup-content");

        if (popupEl) {
            // Handle primary key clicks
            popupEl.querySelectorAll(".primary-key").forEach(elem => {
                elem.addEventListener("click", (e) => {
                    const key = e.target.getAttribute("data-key");
                    const value = e.target.getAttribute("data-value");
                    console.log("Primary Key Clicked:", { key, value });
                    handleOnAction("onFieldAction",key, value)
                });
            });

            // Handle close button click
            const closeBtn = popupEl.querySelector(".popup-close-btn");
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    popup.remove();
                });
            }
        }
    }, 0);

    return popup;
};
